module.exports = __webpack_public_path__ + "static/media/EP02@l.b8e8ee83.jpg";